// start:ng42.barrel
export * from './report-chart.component';
export * from './report-chart-selection.service';
// end:ng42.barrel

